import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import SEOSection from './components/SEOSection';

export default function Home() {
  useEffect(() => {
    document.title = '亚洲一级日本精选内容导航 - 日本文化影视美食旅游资源指南';

    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    scripts.forEach((s) => {
      if (s.textContent?.includes('"@type":"WebSite"') || s.textContent?.includes('"@type":"Organization"')) {
        s.remove();
      }
    });

    const websiteSchema = document.createElement('script');
    websiteSchema.type = 'application/ld+json';
    websiteSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '亚洲一级日本精选内容导航',
      url: 'https://kaxifa.cn/',
      description: '亚洲一级日本专题页，汇聚亚洲一级日本相关优质资源与内容指南，覆盖日本文化、影视、美食、旅游等一级类目。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://kaxifa.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(websiteSchema);

    const orgSchema = document.createElement('script');
    orgSchema.type = 'application/ld+json';
    orgSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '亚洲一级日本精选内容导航',
      url: 'https://kaxifa.cn/',
      description: '亚洲一级日本内容导航平台，提供日本文化、影视、美食、旅游等领域的优质内容聚合服务。',
      foundingDate: '2024',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@kaxifa.cn',
        contactType: 'customer service',
      },
    });
    document.head.appendChild(orgSchema);

    const breadcrumbSchema = document.createElement('script');
    breadcrumbSchema.type = 'application/ld+json';
    breadcrumbSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://kaxifa.cn/',
      }],
    });
    document.head.appendChild(breadcrumbSchema);

    const faqSchema = document.createElement('script');
    faqSchema.type = 'application/ld+json';
    faqSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '亚洲一级日本内容导航是什么？',
          acceptedAnswer: { '@type': 'Answer', text: '亚洲一级日本精选内容导航是一个专注于日本文化、影视、美食、旅游等领域的中文内容聚合平台。我们精心筛选和整理日本相关的一级优质资源与内容，帮助用户快速找到所需的分类信息。' },
        },
        {
          '@type': 'Question',
          name: '网站上的内容多久更新一次？',
          acceptedAnswer: { '@type': 'Answer', text: '我们的内容团队保持每日更新频率，确保为您提供最新、最全面的日本相关资讯。每个分类板块都会定期补充新的文章和资源。' },
        },
        {
          '@type': 'Question',
          name: '如何快速找到我感兴趣的日本内容？',
          acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航直接进入感兴趣的板块，如日本文化、日本影视、日本美食、日本旅游等。每个分类页面都提供了详细的文章列表和相关资源。' },
        },
        {
          '@type': 'Question',
          name: '网站的内容来源是否可靠？',
          acceptedAnswer: { '@type': 'Answer', text: '所有内容均经过专业编辑团队审核，信息来源包括权威媒体报道、官方发布资料以及资深行业专家的供稿。我们严格把控内容质量。' },
        },
        {
          '@type': 'Question',
          name: '亚洲一级日本和其他日本资讯网站有什么不同？',
          acceptedAnswer: { '@type': 'Answer', text: '亚洲一级日本专注于"一级内容"的精选与聚合，不追求数量而是注重质量。我们按照八大一级类目进行系统化组织，让用户能够高效地找到最优质的内容。' },
        },
        {
          '@type': 'Question',
          name: '我可以通过网站联系到日本当地的资源吗？',
          acceptedAnswer: { '@type': 'Answer', text: '我们提供详细的资源导航和联系方式指引，帮助用户对接日本当地的优质资源。如有具体需求，也可以通过"关于我们"页面的联系表单与我们取得联系。' },
        },
      ],
    });
    document.head.appendChild(faqSchema);
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <SEOSection />
      </main>
      <Footer />
    </>
  );
}